import { useEffect, useRef } from 'react';
import { useLocale } from '@/context/LocaleContext';
import { useSettings } from '@/hooks/useSettings';
import { hasStoredLocale } from '@/lib/i18n';
import { catalogs, type Locale } from '@/locales';

const VALID_LOCALES = Object.keys(catalogs) as Locale[];

/**
 * Solo aplica el idioma de la cuenta si no hay preferencia local válida.
 * Nunca pisa un idioma ya elegido en el sidebar / localStorage.
 */
export function SyncAccountLocale() {
  const { setLocale } = useLocale();
  const { data } = useSettings();
  const hasAppliedAccountLocale = useRef(false);

  useEffect(() => {
    if (hasAppliedAccountLocale.current) return;

    const accountLang = data?.accountSettings?.language;
    if (!accountLang || !VALID_LOCALES.includes(accountLang as Locale)) return;

    hasAppliedAccountLocale.current = true;

    if (hasStoredLocale()) return;

    setLocale(accountLang as Locale);
  }, [data?.accountSettings?.language, setLocale]);

  return null;
}
